import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPdf = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="M9.312 2.8c-.878 0-1.6.722-1.6 1.6 0 1.092.607 2.447 1.245 3.72-.499 1.563-1.065 3.237-1.79 4.65-1.482.582-2.805 1.015-3.6 1.655l-.035.04a1.607 1.607 0 0 0 1.14 2.735c.429 0 .842-.16 1.14-.465l.03-.025c.585-.698 1.275-1.966 1.89-3.125 1.417-.557 2.902-1.124 4.335-1.465 1.047.844 2.56 1.4 3.805 1.4.878 0 1.6-.721 1.6-1.6 0-.878-.722-1.6-1.6-1.6-.998 0-2.45.357-3.56.73a11.9 11.9 0 0 1-2.32-3.02c.425-1.307.92-2.615.92-3.63 0-.878-.722-1.6-1.6-1.6m0 .96c.36 0 .64.281.64.64 0 .48-.256 1.365-.555 2.315C9 5.79 8.672 4.904 8.672 4.4c0-.359.281-.64.64-.64m.275 5.475a13 13 0 0 0 1.66 2.11c-.948.26-1.875.592-2.79.94.442-.996.795-2.03 1.13-3.05m6.285 2.045c.36 0 .64.281.64.64 0 .36-.28.64-.64.64-.72 0-1.745-.325-2.565-.78.941-.265 1.967-.5 2.565-.5m-9.55 2.865c-.45.803-.897 1.553-1.21 1.93a.6.6 0 0 1-.44.165.63.63 0 0 1-.64-.64.7.7 0 0 1 .17-.445c.376-.29 1.192-.638 2.12-1.01" />
  </svg>
);
export default SvgPdf;
